import { render, staticRenderFns } from "./modern.vue?vue&type=template&id=043c7ec7&scoped=true&"
import script from "./modern.vue?vue&type=script&lang=js&"
export * from "./modern.vue?vue&type=script&lang=js&"
import style0 from "./modern.vue?vue&type=style&index=0&id=043c7ec7&prod&lang=scss&scoped=true&"
import style1 from "./modern.vue?vue&type=style&index=1&id=043c7ec7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043c7ec7",
  null
  
)

export default component.exports